import { render, staticRenderFns } from "./BeneficiaryRecomendationsData.vue?vue&type=template&id=016a37e6&"
import script from "./BeneficiaryRecomendationsData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryRecomendationsData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryRecomendationsData.vue?vue&type=style&index=0&id=016a37e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports